<ng-container *transloco="let t">
  <form id="inputForm" [formGroup]="inputForm" (ngSubmit)="submit()">
    <div class="row text-center justify-content-center mt-3">
      <div class="col-12 col-sm-8 col-md-6">
        <div class="row no-gutters">
          <div class="col-8">
            <mat-form-field class="w-100" appearance="fill">
              <mat-label>{{t('input-date-time-session.date')}}</mat-label>
              <input matInput [matDatepicker]="picker" placeholder="Seleziona la data" readonly formControlName="date"
                (click)="picker.open()">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="col-1 ml-1">
            <mat-form-field class="w-100" appearance="fill">
              <mat-label>{{t('input-date-time-session.hour')}}</mat-label>
              <input matInput class="text-center" type="string" formControlName="hour" autocomplete="off" />
            </mat-form-field>
          </div>
          <div class="col-1 ml-1 text-center">
            <mat-form-field class="w-100" appearance="fill">
              <mat-label>{{t('input-date-time-session.minute')}}</mat-label>
              <input matInput class="text-center" type="string" formControlName="minute" autocomplete="off" />
            </mat-form-field>
          </div>
          <div class="col-1 ml-1 text-center">
            <mat-form-field class="w-100" appearance="fill">
              <mat-label>{{t('input-date-time-session.second')}}</mat-label>
              <input matInput class="text-center" type="string" formControlName="second" autocomplete="off" />
            </mat-form-field>
          </div>

        </div>
      </div>
    </div>
  </form>
</ng-container>
